import { LocalizationService } from 'services/LocalizationService'

export default class BitmapText extends PIXI.Container{
  constructor(data) {
    super()
    this.data = data
    this.align = data.style.align
    this.valign = data.style.valign
    this.vratio = this.valign === 'bottom' ? 1 : (this.valign === 'center' ? 0.5 : 0)
    this.ratio = this.align === 'right' ? 1 : (this.align === 'center' ? 0.5 : 0)
    this.data.style.fontName = data.style.font

    this.bitmapText = new PIXI.BitmapText(LocalizationService.get(data.text), data.style )
    this.bitmapText.letterSpacing = data.letterSpacing ? data.letterSpacing : 0
    this.bitmapText.anchor.x = this.ratio
    this.bitmapText.x = data.width * this.ratio
    this.bitmapText.anchor.y = this.vratio
    this.bitmapText.y = data.height * this.vratio
    this.text = this.bitmapText
    this.isBitmap = true
    this.addChild(this.bitmapText)
    this.renderText = true
    this.startLength = this.text.text.length

    this.name = data.name

    this.resize()
  }

  renderTextUpdate(update) {
    this.renderText = update
    this.resize()
  }

  resize() {
    if(this.renderText) {
      if (this.bitmapText.width > this.data.width && this.bitmapText.fontSize > 1) {
        this.bitmapText.fontSize = this.bitmapText.fontSize * 0.75
        this.resize()
      }
    }
  }

  update(value, resize = true) {
    this.bitmapText.text = value

    if(this.startLength !== this.text.text.length && resize){
      this.renderText = true
      this.resize()
    }
    this.startLength = this.text.text.length

  }
}
